// extracted by mini-css-extract-plugin
export var completionBody = "_l9-2";
export var completionCard = "_l9-0";
export var completionFooter = "_l9-3";
export var completionTitle = "_l9-1";